import classNames from 'classnames';
import { StateUpdater } from 'preact/hooks';
import { JSXInternal } from 'preact/src/jsx';

interface PopupInputProps extends JSXInternal.HTMLAttributes<HTMLInputElement> {
  errorMessage?: string;
  inputPlaceholder: string;
  inputValue: string;
  isLabelShrink: boolean;
  setIsLabelShrink: StateUpdater<boolean>;
}

export function PopupInput({
  errorMessage,
  inputPlaceholder,
  inputValue,
  className,
  isLabelShrink,
  setIsLabelShrink,
  ...props
}: PopupInputProps) {
  return (
    <div className="flex flex-col gap relative input-group w-full">
      <input
        {...props}
        value={inputValue}
        id="input"
        className={classNames(
          `${
            className ?? ''
          } rounded-[10px] border border-gray-300 bg-white w-full  placeholder-gray-600 h-12 px-4 pt-3 outline-none form-input focus:border-2 text-gray-900`,
          {
            'hover:border-gray-500': !errorMessage,
            'focus:border-primary-500': !errorMessage,
            'border-red-500 border-2': errorMessage,
          },
        )}
        onFocus={() => setIsLabelShrink(true)}
        onBlur={() => setIsLabelShrink(!!inputValue)}
        data-cy="discount-input"
      />
      <label
        for="input"
        className={classNames(
          'text-sm text-gray-600 absolute form-input-label left-[16px] top-[14px] ease-in transition-all duration-100 pointer-events-none',
          {
            'top-[6px] text-xs': isLabelShrink,
          },
        )}
      >
        {inputPlaceholder}
      </label>
      {errorMessage && (
        <span className="text-red-600 text-sm mt-1" data-cy="input-error">
          {errorMessage}
        </span>
      )}
    </div>
  );
}
